﻿onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    context.querySelectorAll('.add-bundle-to-cart').forEach(element => {
        element.querySelector('form').addEventListener('success', () => {
            const products = element.$data.bundleGroups
                .reduce((arr, bundleGroup) => arr.concat(bundleGroup.selectedProducts.map(selectedProduct => bundleGroup.products.find(p => p.id == selectedProduct))), []);

            // Trigger the "cart:added" event.
            element.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { items: products.map(p => ({ id: p.id, name: p.name, categoryName: element.$data.productListing.categoryName, brandName: p.brandName, taxRate: p.taxRate, price: p.price, quantity: p.quantity * element.$data.quantity })) } }));
        });
    });
}